import type { TDateRegion, TDatePart } from "./types";

const formatDatePart = (
    availableDateParts: TDatePart[],
    isUS: boolean,
): string => {
    if (availableDateParts.length === 0) return "";

    const dateOrder = isUS
        ? ["month", "day", "year"]
        : ["day", "month", "year"];
    return dateOrder
        .filter(part =>
            availableDateParts.includes(part as "day" | "month" | "year"),
        )
        .map(part => {
            switch (part) {
                case "day":
                    return "dd";
                case "month":
                    return "MM";
                case "year":
                    return "yyyy";
                default:
                    return "";
            }
        })
        .join("/");
};

const formatTimePart = (timeParts: TDatePart[], isUS: boolean): string => {
    if (timeParts.length === 0) return "";

    return timeParts
        .map(part => {
            switch (part) {
                case "hour":
                    return isUS ? "hh" : "HH";
                case "minute":
                    return "mm";
                case "second":
                    return "ss";
                case "millisecond":
                    return ".SSS";
                default:
                    return "";
            }
        })
        .join(":")
        .replace(":.", ".");
};

export const getDateFnsFormat = (
    parts: TDatePart[],
    region: TDateRegion,
): string => {
    const isUS = region === "en-US";

    const availableDateParts = parts.filter(part =>
        ["day", "month", "year"].includes(part),
    );
    const timeParts = parts.filter(part =>
        ["hour", "minute", "second", "millisecond"].includes(part),
    );

    const datePart = formatDatePart(availableDateParts, isUS);
    const timePart = formatTimePart(timeParts, isUS);
    const amPmPart = isUS && timeParts.includes("hour") ? " a" : "";

    return [
        datePart,
        timePart && datePart ? ", " : "",
        timePart,
        amPmPart,
    ].join("");
};
